module.exports = __webpack_public_path__ + "img/facebook_active.c44ffb80.png";